export default __webpack_public_path__ + "88606e902c86e0d39902731a066b6799.png";